


export const roomsData =
  [
    {
      "id": 1,
      "room_number": 101,
      "room_type": "Standard",
      "status": "occupied",
      "amenities": ["non-smoking", "cleaning"]
    },
    {
      "id": 2,
      "room_number": 102,
      "room_type": "Standard",
      "status": "available",
      "amenities": ["smoking", "cleaning", "bed", "wifi"]
    },
    {
      "id": 3,
      "room_number": 103,
      "room_type": "Standard",
      "status": "reserved",
      "amenities": ["non-smoking", "ac", "cleaning", "bed"]
    },
    {
      "id": 4,
      "room_number": 201,
      "room_type": "Deluxe",
      "status": "occupied",
      "amenities": ["non-smoking", "cleaning"]
    },
    {
      "id": 5,
      "room_number": 202,
      "room_type": "Deluxe",
      "status": "available",
      "amenities": ["non-smoking", "ac", "cleaning", "bed"]
    },
    {
      "id": 6,
      "room_number": 203,
      "room_type": "Deluxe",
      "status": "reserved",
      "amenities": ["non-smoking", "cleaning"]
    },
    {
      "id": 7,
      "room_number": 301,
      "room_type": "Superior",
      "status": "occupied",
      "amenities": ["smoking", "cleaning", "bed", "wifi"]
    },
    {
      "id": 8,
      "room_number": 302,
      "room_type": "Superior",
      "status": "available",
      "amenities": ["non-smoking", "cleaning"]
    },
    {
      "id": 9,
      "room_number": 303,
      "room_type": "Superior",
      "status": "reserved",
      "amenities": ["non-smoking", "ac", "cleaning", "bed"]
    },
    {
      "id": 10,
      "room_number": 304,
      "room_type": "Superior",
      "status": "available",
      "amenities": ["non-smoking", "cleaning"]
    }
  ]
